<template>
  <div>
    <b-row>
      <b-col class="text-center">
        <h3>Ler os dados da Nota Fiscal</h3>
      </b-col>
    </b-row>
    <validation-observer #default="{ handleSubmit }"
                         ref="refFormAddCuponObserver"
    >
      <b-form @submit.prevent="handleSubmit(addCoupon)">
        <b-row class="justify-content-center align-content-center align-items-center text-center">
          <b-col>
            <b-button-group
              size="sm"
            >
              <b-button
                :variant="typeSearch === 'key' ? '' : 'outline-dark'"
                :style="typeSearch === 'key' ? getStyle : ''"
                @click="setTypeSearch('key')"
              >
                Chave
              </b-button>
              <b-button
                :variant="typeSearch === 'qrcode' ? '' : 'outline-dark'"
                :style="typeSearch === 'qrcode' ? getStyle : ''"
                @click="setTypeSearch('qrcode')"
              >
                QRCode
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>

        <b-row v-if="typeSearch === 'key'">
          <b-col xs="12" class="d-flex justify-content-center">
            <div class="form-container">
              <i2-form-input
                id="key"
                v-model="model.keyValue"
                label="Chave"
                name="key"
                class="w-100"
              />
              <div class="button-container mt-2">
                <b-button
                  :style="getStyle"
                  class="btn-icon w-100"
                  @click="executeSearch"
                >
                  <feather-icon icon="SearchIcon"/>
                </b-button>
              </div>
            </div>
          </b-col>

        </b-row>
        <b-row v-if="typeSearch === 'qrcode'">
          <b-col xs="12" class="d-flex justify-content-center">
            <div class="form-container">
              <i2-form-input
                id="qrcode"
                v-model="model.qrcodeValue"
                label="Ler QRCode"
                name="qrcode"
                class="w-100"
              />
              <div class="button-container mt-2">
                <b-button
                  :style="getStyle"
                  class="btn-icon"
                  @click="startQrCodeReader"
                >
                  <feather-icon icon="CameraIcon"/>
                </b-button>
                <b-button
                  :style="getStyle"
                  class="btn-icon ml-2"
                  @click="executeSearch"
                >
                  <feather-icon icon="SearchIcon"/>
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="isSearchingInvoice" class="justify-content-center align-content-center align-items-center mt-1">
          <div class="alert custom-alert-success">
            <h1>Atenção, aguarde! Estamos buscando os dados da nota informada!</h1>
            <p>
              A pesquisa pode demorar alguns minutos. Por favor aguarde enquanto consultamos os dados da nota e
              tente novamente dentro de alguns minutos <a href="#" @click="executeSearch">clicando aqui</a> ou
              no botão com o ícone de lupa.
            </p>
          </div>
        </b-row>

        <b-row v-if="isShowScanner" class="justify-content-center mt-2">
          <b-col sm="12" md="6">
            <div id="reader"></div>
          </b-col>
        </b-row>

        <!-- dynamic fields -->
        <b-row
          v-if="availableDynamicFields.length > 0"
          class="justify-content-center align-content-center align-items-center"
        >
          <b-col v-for="field in availableDynamicFields" :key="field.uuid" md="4">
            <i2-form-input
              :key="field.uuid"
              v-model="modelDynamicField[field.slug]"
              :label="field.label"
              :name="field.slug"
              rules="required"
            />
          </b-col>

        </b-row>

        <b-row v-if="currentInvoice" id="containerForm">
          <b-col cols="12">
            <i2-form-input
              v-model="labelLocation"
              readonly
              label="Local"
              name="emitente"
            />
          </b-col>
          <b-col cols="3">
            <i2-form-input
              :value="labelDocument"
              readonly
              label="CNPJ"
              name="cnpj"
            />
          </b-col>
          <b-col cols="5">
            <i2-form-input
              :value="labelCityState"
              readonly
              label="Cidade / Estado"
              name="city_state"
            />
          </b-col>
          <b-col cols="4">
            <i2-form-input
              v-model="sumSelectedValues"
              label="Total Selecionado"
              name="selectedTotal"
              readonly
            />
          </b-col>
          <b-col v-if="shouldShowProductLauncher" cols="12">
            <hr>
            <div class="alert">
              <h1><b>Atenção!</b></h1>
              <p>
                Esta nota pertence a um estado que não fornece os produtos para consulta, neste caso é necessário
                preencher o
                nome do item e o valor, exatamente como consta na sua nota fiscal. Informe <b>apenas os produtos
                  participantes
                  da promoção</b>.
              </p>
            </div>
            <h4>Adicionar Produto</h4>
            <b-row class="align-content-center align-items-center">
              <b-col cols="12" md="5">
                <i2-form-input
                  v-model="newProduct.description"
                  label="Produto (igual consta na nota fiscal)"
                  name="product_description"
                />
              </b-col>
              <b-col cols="12" md="3">
                <i2-form-input
                  v-model="newProduct.value"
                  label="Valor Total"
                  name="product_value"
                  type="number"
                  step="0.01"
                />
              </b-col>
              <b-col cols="12" md="4">
                <b-button
                  variant="primary"
                  :style="getStyle"
                  class="w-100"
                  @click="addProduct"
                >
                  Adicionar Produto
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <b-table
              :items="currentInvoice.invoice_data_api.produtos"
              :fields="[
                { key: 'selecionar', label: '#', class: 'w-5' },
                { key: 'nome', label: 'Nome do Produto' },
                { key: 'total', label: 'Valor Total' }
              ]"
            >
              <template #cell(selecionar)="{ item, index }">
                <b-form-checkbox
                  :key="`checkbox-${index}`"
                  v-model="productSelections[index]"
                  @change="toggleProductSelection(item, index)"
                />
              </template>

              <template #cell(nome)="{ value }">
                <span>{{ value }}</span>
              </template>
              <template #cell(total)="{ value }">
                <span>R$ {{ value }}</span>
              </template>
            </b-table>
          </b-col>
        </b-row>

        <b-row v-if="currentInvoice" class="justify-content-center align-content-center align-items-center">
          <b-col md="8" sm="8">
            <b-button block :disabled="selectedProducts.length === 0" class="btn-icon"
                      :style="{...getStyle, minHeight: '70px'}"
                      @click="getMyNumbers"
            >
              Gerar meus números
            </b-button>
          </b-col>
        </b-row>

      </b-form>
      <b-row v-if="isShowNumbers" class="justify-content-center align-content-center align-items-center">
        <div class="alert custom-alert-success">
          <h4>Número(s) Gerado(s)</h4>
          <div v-for="item in luckNumbers" :key="item.uuid">
            {{ item.full_number }}
          </div>
        </div>
      </b-row>
      <b-row v-if="currentInvoice && !shouldShowProductLauncher"
             class="justify-content-center align-content-center align-items-center mt-1"
      >
        <div class="alert">
          <h1>Atenção</h1>
          <p>
            Você deve selecionar os produtos participantes da promoção <b>{{ currentPromotion.name }}</b>. Caso informe
            produtos não participantes, você será <b>desclassificado</b>.
          </p>
        </div>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>

import { ValidationObserver } from 'vee-validate'
// import { Html5Qrcode } from 'html5-qrcode'

export default {
  name: 'ParticipantFormNfeCoupon',
  components: { ValidationObserver },
  props: {
    getStyle: {},
    promotion: {
      type: Object,
      required: true,
    },
    httpConfig: {
      type: Object,
      required: true,
    },
    document: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isSearchingInvoice: false,
      itemsInvoice: [],
      keyValue: '',
      qrcodeValue: '',
      selectedProducts: [],
      productSelections: [],
      currentInvoice: null,
      typeSearch: '',
      isShowNumbers: false,
      isShowScanner: false,
      html5QrCode: null,
      luckNumbers: [],
      currentPromotion: {},
      coupon: {
        files: '',
        value: '',
      },
      model: {
        type: '',
        value: '',
        items: [],
      },
      availableDynamicFields: [],
      modelDynamicField: {},
      newProduct: {
        description: '',
        value: '',
      },
    }
  },
  computed: {
    sumSelectedValues() {
      if (!this.selectedProducts || this.selectedProducts.length === 0) {
        return 'R$ 0,00'
      }

      const total = this.selectedProducts.reduce((acc, produto) => {
        const valor = typeof produto.total === 'string'
          ? parseFloat(produto.total.replace(/[^\d,.-]/g, '').replace(',', '.'))
          : Number(produto.total)

        return acc + (isNaN(valor) ? 0 : valor)
      }, 0)

      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(total)
    },
    labelCityState() {
      if (this.currentInvoice?.invoice_data_api?.emitente?.cidade && this.currentInvoice?.invoice_data_api?.emitente?.uf) {
        return `${this.currentInvoice.invoice_data_api.emitente.cidade} ${this.currentInvoice.invoice_data_api.emitente.uf}`
      }
      return 'Não localizado'
    },
    labelLocation() {
      return this.currentInvoice?.invoice_data_api?.emitente?.razao_social || 'Não localizado'
    },
    labelDocument() {
      return this.currentInvoice?.invoice_data_api?.emitente?.cnpj || this.currentInvoice?.invoice_data_api?.emitente
    },
    shouldShowProductLauncher() {
      return this.currentInvoice?.invoice_data_api?.status === 'parcial'
    },
  },
  mounted() {
    this.currentPromotion = this.promotion
    this.startFields()
  },
  methods: {
    toggleProductSelection(item, index) {
      if (this.productSelections[index]) {
        // Converter o valor para número antes de adicionar
        const valorTotal = typeof item.total === 'string'
          ? parseFloat(item.total.replace(/[^\d,.-]/g, '').replace(',', '.'))
          : Number(item.total)

        // Verificar se já não existe um produto com o mesmo índice
        const existingIndex = this.selectedProducts.findIndex(p => p._index === index)
        if (existingIndex === -1) {
          const produto = {
            ...item,
            _index: index,
            total: isNaN(valorTotal) ? 0 : valorTotal,
          }
          this.selectedProducts.push(produto)
        }
      } else {
        const idx = this.selectedProducts.findIndex(p => p._index === index)
        if (idx > -1) {
          this.selectedProducts.splice(idx, 1)
        }
      }
    },
    async stopQrCodeReader() {
      if (this.html5QrCode) {
        try {
          await this.html5QrCode.stop()
          this.html5QrCode = null
        } catch (err) {
          console.error('Erro ao parar o leitor:', err)
        }
      }
    },
    async startQrCodeReader() {
      try {
        const { Html5Qrcode } = await import('html5-qrcode')

        this.isShowScanner = true
        await this.$nextTick()

        // Para o scanner anterior se existir
        await this.stopQrCodeReader()

        this.html5QrCode = new Html5Qrcode('reader')
        const config = {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        }

        await this.html5QrCode.start(
          { facingMode: 'environment' },
          config,
          async decodedText => {
            this.model.qrcodeValue = decodedText
            await this.stopQrCodeReader()
            this.isShowScanner = false
            await this.executeSearch()
          },
          () => {
          }, // Ignora erros de leitura
        )
      } catch (err) {
        console.error('Erro ao iniciar o leitor:', err)
        this.$notify.error('Erro ao acessar a câmera. Verifique as permissões.')
      }
    },
    startFields() {
      this.availableDynamicFields = []
      if (this.currentPromotion.settings.form?.fields?.length > 0) {
        this.currentPromotion.settings.form.fields.forEach(field => {
          if (field.slug !== '') {
            this.modelDynamicField[field.slug] = ''
            this.availableDynamicFields.push(field)
          }
        })
      }
    },
    async getMyNumbers() {
      this.$refs.refFormAddCuponObserver.validate().then(async success => {
        if (!success) {
          return
        }

        const data = {
          document: this.document.replace(/[.\-/]/g, ''),
          prize_draw_coupon_uuid: this.currentInvoice.uuid,
          dynamic_fields: JSON.stringify(this.modelDynamicField),
          selected_products: this.selectedProducts,
        }

        const response = await this.$http.post(`/promotion/${this.promotion.uuid}/invoice`, data, this.httpConfig)
        if (response.error || response.error_message) {
          this.$notify.error(response.error_message)
          return
        }

        if (response.message) {
          this.$notify.warning(response.message)
        } else {
          this.$notify.success('Cupons enviados e números gerados com sucesso.')
          this.luckNumbers = response
          this.isShowNumbers = true
        }
        this.currentInvoice = null
        this.resetForm()
        this.$refs.refFormAddCuponObserver.reset()
      })
    },
    resetForm() {
      this.startFields()
      this.coupon.files = null
      this.coupon.value = 0
    },
    setTypeSearch(type) {
      this.clearInvoiceForm()
      this.model.type = type
      this.typeSearch = type
      if (type === 'key') {
        this.isShowScanner = false
      }
    },
    async executeSearch() {
      this.clearInvoiceForm()

      this.currentInvoice = null
      this.model.document = this.document.replace(/[.\-/]/g, '')
      this.isSearchingInvoice = false
      const value = this.typeSearch === 'key' ? this.model.keyValue : this.model.qrcodeValue
      const searchModel = {
        ...this.model,
        value,
      }

      if (this.typeSearch === 'key' && (!this.model.keyValue || this.model.keyValue.length !== 44)) {
        this.$notify.warning('Informe uma chave com 44 caracteres.')
        return
      }

      if (this.typeSearch === 'qrcode' && (!this.model.qrcodeValue || this.model.qrcodeValue.length <= 0)) {
        this.$notify.warning('Informe uma URL válida para pesquisa.')
        return
      }

      const response = await this.$http.post(`/promotion/${this.promotion.uuid}/search`, searchModel, this.httpConfig)
      if (response.error || response.error_message) {
        this.$notify.error(response.error_message)
        return
      }

      if (response.is_searching === true) {
        this.isSearchingInvoice = true
        return
      }

      this.currentInvoice = response
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)
    },
    addProduct() {
      if (!this.newProduct.description || !this.newProduct.value) {
        this.$notify.warning('Preencha todos os campos do produto')
        return
      }

      const valorNumerico = parseFloat(this.newProduct.value)
      if (isNaN(valorNumerico)) {
        this.$notify.warning('O valor informado é inválido')
        return
      }

      if (!this.currentInvoice.invoice_data_api.produtos) {
        this.$set(this.currentInvoice.invoice_data_api, 'produtos', [])
      }

      const produto = {
        nome: this.newProduct.description,
        total: valorNumerico,
      }

      this.currentInvoice.invoice_data_api.produtos.push(produto)
      const newIndex = this.currentInvoice.invoice_data_api.produtos.length - 1

      if (!this.productSelections) {
        this.productSelections = []
      }

      this.$set(this.productSelections, newIndex, true)
      this.toggleProductSelection(produto, newIndex)

      this.newProduct.description = ''
      this.newProduct.value = ''

      this.$notify.success('Produto adicionado com sucesso')
    },
    clearInvoiceForm() {
      this.currentInvoice = null
      this.selectedProducts = []
      this.productSelections = []
      this.isShowNumbers = false

      this.newProduct.description = ''
      this.newProduct.value = ''
    },
  },
}
</script>

<style scoped>

.alert {
  background-color: #fff9c4; /* Tonalidade suave de amarelo */
  color: #5f5f5f; /* Cinza escuro para texto */
  border: 1px solid #ffeb3b; /* Borda amarela clara */
  border-radius: 8px; /* Cantos arredondados */
  padding: 8px 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Sombra discreta */
  width: 100%;
}

.alert h1 {
  text-align: left;
  font-size: 10px;
  margin: 0;
  margin-bottom: 10px;
}

.alert p {
  text-align: left;
  margin: 0;
  font-size: 9px;
  line-height: 1.5;
}

.custom-alert-success {
  background-color: #d1fad1; /* Verde suave que remete ao sucesso */
  color: #155724; /* Cor do texto remanescente de sucesso */
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #a2d9a2; /* Uma borda verde que define melhor o conteúdo */
}

#reader {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

#reader video {
  width: 100%;
}

.form-container {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.button-container {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.btn-icon {
  min-width: 120px;
}

@media (min-width: 768px) {
  .form-container {
    width: 50%;
    flex-direction: row;
    align-items: flex-start;
  }

  .form-container .w-100 {
    flex-grow: 1;
    margin-right: 1rem;
  }

  .button-container {
    width: auto;
    margin-top: 2rem !important;
  }

  .btn-icon {
    min-width: auto;
  }
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.product-card {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.3s ease;
}

.product-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.product-card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-info {
  flex: 1;
}

.product-title {
  margin: 0;
  font-size: 1rem;
  color: #333;
  word-break: break-word;
}

.product-price {
  margin: 0.5rem 0 0;
  color: #666;
  font-weight: 500;
}

.delete-btn {
  padding: 0.4rem;
  min-width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .products-grid {
    grid-template-columns: 1fr;
  }

  .product-card {
    margin-bottom: 0.5rem;
  }
}

</style>
